import styled, { css } from "styled-components";

import { LoginPageContainer } from "../../templates/LoginPageTemplate/styled";
import { FlexContainers, Heading3, Paragraph2 } from "../../components";
import { TooltipWrapper } from "../../components/Tooltip/styled";

const ErrorWrapperActive = css`
  max-height: 30vh;
`;

const FetchingDataWrapperWithError = css`
  max-width: 950px;
  max-height: 780px;
`;

export const ErrorWrapper = styled(FlexContainers.FlexColumn)`
  overflow: scroll;

  max-height: 0;
  padding-right: 35px;
  transition: max-height 0.25s ease-out;

  ${Paragraph2} {
    text-align: left;
    width: 100%;
  }

  svg {
    cursor: pointer;
  }
`;

export const FetchingDataWrapper = styled(LoginPageContainer)`
  padding: 76px 72px;
  max-height: 270px;
  transition: max-height 0.25s ease-out, max-width 0.25s ease-out;

  max-width: 678px;

  ${ErrorWrapper} {
    ${(props) => props.isActive && ErrorWrapperActive}
  }

  ${(props) => props.isError && FetchingDataWrapperWithError}
`;

export const ButtonTooltip = styled(TooltipWrapper)`
  visibility: ${(props) => (props?.visible ? "visible" : "hidden")};
  transform: translate(20px, -35px);
`;

export const ButtonWrapper = styled(FlexContainers.FlexRowEnd)`
  position: relative;
  width: 100%;

  transform: translate(-10px, 25px);
`;

export const FetchingDataTitle = styled(Heading3)`
  font-weight: 800;
  font-size: 24px;
`;
